import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { ShopTwoTone } from '@ant-design/icons';

const Container = styled.section`
  width: 225px;
  background-color: var(--fett-chat-card-bg);
  border: solid 2px var(--fett-chat-card-border);
  border-radius: 2px;
  > h4 {
    margin-bottom: 0;
    padding: 5px;
    font-size: 16px;
    font-weight: 400;
    color: var(--fett-text-primary);
    border-bottom: solid 1px var(--fett-border-default);
  }
  > div {
    display: flex;
    align-items: center;
    padding: 8px;
    > span {
      margin-right: 5px;
      font-size: 46px;
    }
    > p {
      flex: 1 0 0;
      margin-bottom: 0;
      color: var(--fett-text-tertiary);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export interface FollowCardMessageProps extends HTMLAttributes<HTMLDivElement> {
  storeName?: string;
}

function FollowCardMessage(props: FollowCardMessageProps) {
  const { storeName, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <Container {...otherProps}>
      <h4>{t('ViewsChat.邀请关注店铺')}</h4>
      <div>
        <ShopTwoTone twoToneColor="#F09466" />
        <p title={storeName}>{storeName || '-'}</p>
      </div>
    </Container>
  );
}

export default FollowCardMessage;
